(ns ncr.scratch.pf
  (:require
   [ncr.widgets.core :as w]
   [ncr.etc.pf :as pf]))

(defn c-scratch-panel [{:keys [title]} body]
  [pf/c-panel
   [pf/c-panel-header title]
   [pf/c-panel-main
    [pf/c-panel-main-body
     body]]])

(defn c-dropdown-menu []
  [pf/c-split
   [pf/c-dropdown-menu
    [pf/c-menu {:is-plain true}
     [pf/c-menu-item
      {:icon [w/c-menu-icon {:icon :eye-outline}]}
      "Menu Item #1"]]]

   [pf/c-dropdown-menu
    [pf/c-menu {:is-plain true}
     [pf/c-menu-item
      {:icon [w/c-menu-icon {:icon :eye-outline}]}
      "Menu Item #1"]]]])

(defn c-component []
  [:<>
   [c-scratch-panel {:title "c-dropdown-menu"}
    [c-dropdown-menu]]
   [:br]])




